import { SidenavParams } from '../sidenav/interfaces';

export const defaultSidenavCssParams = {
  MAX_WIDTH_EXPAND: 17.5,
  MIN_WIDTH_EXPAND: 13.125,

  MENU_ICON: 3.75,
  PADDING_PER_CHILD: 3.75,

  EXPAND_MENU_ICON: 2.75, // icon width + padding
  BUTTON_PADDING_RIGHT: 1
};

export const DefaultSidenavParams: SidenavParams = {
  childIndentValue: defaultSidenavCssParams.PADDING_PER_CHILD,
  displayToAnonymousUser: false,
  expanded: false,
  footerOffset: true,
  hideChangeCompanyButton: false,
  hideCompanyNameInCompactMode: false,
  hideLogoutButton: false,
  lockExpansion: false,
  mobileOpened: true,
  mobileViewWidthBreakpoint: 62,
  useDefaultHelpItem: true,
  disableBackdropClose: false,
  suppressChangeCompanyDialog: false,
  enableContentResizing: false
};
